import React from 'react';
import { Check, CheckCheck } from 'lucide-react';
import { formatRelativeDateTime } from '@/lib/utils';

const LABELS = {
  sent: 'Gesendet',
  delivered: 'Zugestellt',
  read: 'Gelesen',
};

export default function MessageDeliveryStatus({ message, className = '', variant = 'full' }) {
  const status = message?.delivery_status || 'sent';
  const recipients = message?.recipient_statuses || [];
  const timestamp = status === 'read'
    ? message?.read_at
    : status === 'delivered' ? message?.delivered_at : (message?.sent_at || message?.created_at);
  const Icon = status === 'sent' ? Check : CheckCheck;
  const readCount = recipients.filter((recipient) => recipient.status === 'read').length;
  const groupSummary = recipients.length > 1
    ? (variant === 'app'
      ? `Gelesen von ${readCount}/${recipients.length}`
      : `${recipients.length} Empfänger · ${
        recipients.filter((recipient) => ['delivered', 'read'].includes(recipient.status)).length
      } zugestellt · ${readCount} gelesen · ${
        recipients.filter((recipient) => recipient.status !== 'read').length
      } ungelesen`)
    : null;

  return (
    <details className={`relative ${className}`} data-testid={`message-status-${message?.id}`}>
      <summary className="list-none cursor-pointer inline-flex items-center gap-1" title="Zustelldetails">
        <Icon className="w-3 h-3" />
        <span>
          {groupSummary || LABELS[status]}
          {!groupSummary && timestamp ? ` · ${formatRelativeDateTime(timestamp)}` : ''}
        </span>
      </summary>
      {recipients.length > 0 && (
        <div className="absolute right-0 z-20 mt-1 min-w-64 rounded-md border border-slate-200 bg-white p-2 text-slate-700 shadow-lg">
          {recipients.map((recipient) => {
            const when = recipient.status === 'read' ? recipient.read_at
              : recipient.status === 'delivered' ? recipient.delivered_at : (message.sent_at || message.created_at);
            const label = recipient.status === 'read'
              ? LABELS.read
              : `${LABELS[recipient.status]} · ungelesen`;
            return (
              <div key={recipient.user_id} className="flex justify-between gap-3 py-1 text-[11px]">
                <span className="font-medium">{recipient.full_name || recipient.username || recipient.user_id}</span>
                <span className="whitespace-nowrap">
                  {label}{when ? ` · ${formatRelativeDateTime(when)}` : ''}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </details>
  );
}
